<template>
  <b-form-group
    id="fieldset-1"
    :label="label"
    label-for="input-1"
    :label-class="'text-muted d-block ' + labelClass"
    :state="fieldState"
    :invalid-feedback="fieldInvalidFeedback"
    class="mb-0"
  >
    <b-input-group :prepend="prepend && !append ? '€' : ''" :append="append ? '€' : ''" :class="{ readonly: disabled }">
      <b-form-input
        v-model="displayValue"
        type="text"
        :readonly="readonly"
        :disabled="disabled"
        @keyup="$emit('keyup', arguments)"
        @focus="$emit('focus', arguments[0])"
        @blur="onBlur"
        @keypress="isValidKey"
        :state="fieldState"
        :ref="inputRef"
        :class="inputClass"
        :id="id || 'akcur-' + _uid.toString()"
        required="required"
        :form="form"
        :placeholder="placeholder"
        :autofocus="autofocus"
      />
    </b-input-group>
  </b-form-group>
</template>

<script>
import SettingsStore from '@/store/Settings';
function unformatCurrency(inputValue) {
  if (typeof inputValue == 'string')
    return parseFloat(
      inputValue
        .replace(/[^0-9,.-]/g, '')
        .replaceAll('.', '')
        .replaceAll(',', '.')
    );
}
function formatCurrency(inputValue, digitsToShow = 2) {
  const floatValue = parseFloat(inputValue); //unformatCurrency(inputValue);

  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: digitsToShow,
    maximumFractionDigits: digitsToShow
  })
    .format(floatValue)
    .slice(0, -2);

  //  else return parseInt(floatValue);
}
export default {
  data() {
    return {
      displayValue: null,
      fieldState: null,
      fieldInvalidFeedback: '',
      element: null
    };
  },
  computed: {},
  mounted() {
    var id = this.id;
    if (!id) {
      id = 'akcur-' + this._uid.toString();
    }
    this.element = document.querySelector('#' + id);

    if (this.value === '' || this.value == null || this.displayValue == '') return (this.displayValue = '');
    //const showDigits =
    this.element && this.element.disabled == false ? 2 : SettingsStore.settings['Centbetraege'] == true ? 2 : 0;
    this.displayValue = formatCurrency(this.value, SettingsStore.settings['Centbetraege'] == true ? 2 : 0); // FORMAT here
  },
  props: {
    autofocus: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String]
    },
    label: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    append: {
      type: Boolean,
      default: false
    },
    prepend: {
      type: Boolean,
      default: true
    },
    decimals: {
      type: Boolean,
      default: true
    },
    inputClass: {
      type: String
    },
    min: {
      type: [Number, String]
    },
    max: {
      type: [Number, String]
    },
    inputRef: {
      type: String
    },
    form: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    customValidator: {
      type: Function,
      default(value) {
        if (this.min && parseFloat(value) < parseFloat(this.min)) {
          return (
            'Wert muss größer gleich ' +
            formatCurrency(this.min, SettingsStore.settings['Centbetraege'] == true ? 2 : 0) +
            ' sein'
          );
        }
        if (this.max && parseFloat(value) > parseFloat(this.max)) {
          return (
            'Wert muss kleiner gleich ' +
            formatCurrency(this.max, SettingsStore.settings['Centbetraege'] == true ? 2 : 0) +
            ' sein'
          );
        }
        return true;
      }
    }
  },
  watch: {
    value(e) {
      //console.log('zzz value changed', e);
      this.displayValue = formatCurrency(e, 2); // FORMAT here
      if (this.disabled) {
        if (SettingsStore.settings['Centbetraege'] == false) this.displayValue = formatCurrency(this.value, 0);
      }
      //console.log('zzz watch value 2', e, this.value, this.displayValue);
      if (isNaN(this.value) || e == null) this.displayValue = '';
    },
    disabled(isDisabled) {
      /*var showDigits = 0;

      // wenn das feld im disabled state ist, sollen nachkommastellen abhängig von der einstellung angezeigt werden
      if (e == true) showDigits = SettingsStore.settings['Centbetraege'] ? 2 : 0;
      else showDigits = 2;
*/
      this.displayValue = formatCurrency(this.value, 2); // FORMAT here
      if (isDisabled) {
        if (SettingsStore.settings['Centbetraege'] == false) this.displayValue = formatCurrency(this.value, 0);
      }
      if (!this.value || (this.value && isNaN(this.value))) this.displayValue = '';
      //console.log('zzz watch disabled', isDisabled, this.value, isNaN(this.value), this.displayValue);
      //console.log('this.displayValue', this.displayValue);
      //console.log('this.value', this.value);
    }
  },
  methods: {
    onBlur() {
      const floatValue = unformatCurrency(this.displayValue); // convert the formatted text back into a raw float number

      //console.log('zzz onBlur floatValue', floatValue, isNaN(floatValue));
      if (typeof floatValue == 'undefined' || isNaN(floatValue)) {
        this.displayValue = '';
        if (this.required) {
          this.fieldState = false;
          //this.fieldInvalidFeedback = result;
          //this.element.setCustomValidity('req');
          this.element.reportValidity();
          this.$nextTick(() => {
            this.element.select();
          });
          return;
        }
      } else {
        /*
        const showDigits =
          this.element.disabled == false && this.element.readonly == false
            ? 2
            : SettingsStore.settings['Centbetraege'] == true
            ? 2
            : 0;*/
        //console.log("zzz digits", showDigits, SettingsStore.settings['Centbetraege'] == true ? 2 : 0)
        this.displayValue = formatCurrency(floatValue, 2);

        const result = this.customValidator(floatValue);
        if (result && result == true) {
          this.fieldState = null;
          this.fieldInvalidFeedback = null;
          this.element.setCustomValidity('');
        } else if (result && result != true) {
          this.fieldState = false;
          //this.fieldInvalidFeedback = result;
          this.element.setCustomValidity(result);
          this.element.reportValidity();
          this.$nextTick(() => {
            this.element.select();
          });
        }
      }
      this.$emit('input', floatValue);
      this.$emit('update', floatValue);
    },
    isValidKey(evt) {
      this.fieldInvalidFeedback = null;
      this.element.setCustomValidity('');
      //const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-'];
      //if (SettingsStore.settings['Centbetraege']) keysAllowed.push(',');
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-', ','];

      if (this.min && this.min >= 0) keysAllowed.splice(keysAllowed.indexOf('-'), 1);

      const keyPressed = evt.key;

      if (
        !keysAllowed.includes(keyPressed) ||
        (keyPressed == '-' && this.displayValue && this.displayValue.toString().includes('-')) // nur ein MInuszeichen zulassen, sonst NaN Gefahr
      ) {
        evt.preventDefault();
      }
    }
  }
};
</script>

<style>
.was-validated .form-control:invalid,
.form-control.is-invalid {
  color: #b14e58;
}
.text-small {
  font-size: 0.875em;
}
/*
.input-group.readonly > * > .input-group-text {
  border: 1px solid #ced4da !important;
  background-color: #e9ecef !important;
}
*/
</style>
